import { toastController } from '@ionic/vue'
import type { PredefinedColors, ToastButton, ToastPosition } from '@ionic/core'

type TToast = {
  message: string
  buttons?: Array<ToastButton>
  color?: PredefinedColors
  position?: ToastPosition
}

export default async function presentToast(toast: TToast) {
  try {
    await toastController.dismiss()
  } catch {
    // toastController throws when dismissing with no existing toast, we can ignore this
  }

  const noButtons =
    !toast.buttons || !(toast.buttons && toast.buttons?.length > 0)
  const toastElement = await toastController.create({
    position: toast.position ?? 'top',
    message: toast.message,
    buttons: toast.buttons,
    color: toast.color ?? 'success',

    //toast can be clicked away, when there are no buttons
    htmlAttributes: noButtons
      ? { onClick: () => toastController.dismiss() }
      : undefined,
    duration: 5000,

    //styles like box-shadow and border-radius are applied in AppGlobalComponentSetup
    //since they don't apply from here
    cssClass:
      'text-gray-700 font-medium font-dmsans md:w-3/4 left-1/2 -translate-x-1/2'.concat(
        !toast.buttons || !(toast.buttons && toast.buttons?.length > 0)
          ? ' text-center text-base'
          : '',
      ),
  })
  return toastElement.present()
}
